import React from "react";
import { Card } from "react-bootstrap";

const styles = {
	root: {
		display: "flex",
		justifyContent: "space-around",
		// alignItems: "center",
		textAlign: "center",
		height: "70vh",
		flexDirection: "column",
	},
};

export const Page404 = () => (
	<div style={styles.root}>
		<Card>
			<div style={{ margin: "0 auto", width: "300px" }}>
				<h1>Page not found</h1>
			</div>
			<div style={{ margin: "0 auto", width: "100px" }}>
				<h1>404</h1>
			</div>
			<div style={{ margin: "0 auto", width: "450px" }}>
				<h3>The page you requested was not found</h3>
			</div>
		</Card>
	</div>
);
